
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/wishlist",
      function () {
        return require("private-next-pages/profile/wishlist.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/wishlist"])
      });
    }
  